const config =
  (document as Document & { config?: Record<string, string> }).config || {};

export default {
  GATEWAY_URL: config.GATEWAY_URL || process.env.REACT_APP_GATEWAY_URL,
};
